import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=c62fca88&scoped=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=js"
export * from "./EmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&id=c62fca88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62fca88",
  null
  
)

export default component.exports